/**
 * Origem real do lead da Black.
 * - Os botões internos apontam para /black-lista?ponto=<ponto de contato>, sem UTMs próprias.
 * - No clique, anexamos as UTMs com que a pessoa chegou ao site (guardadas na sessão),
 *   ou utm_source=direto, e o parâmetro visita=pago|organico (para o CPL pago).
 */
import { blackScheduledHref } from "./offer-rules";

const KEY = "feo-b26-visita";
const UTM_KEY = "feo_utms";
const UTMS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"] as const;
const PAGO_MEDIUM = /(cpc|ppc|paid|ads|cpm|display|pmax|search)/i;

export function blackListaHref(ponto: string) {
  return blackScheduledHref(`/black-lista?ponto=${encodeURIComponent(ponto)}`, Date.now());
}

function detectar(): "pago" | "organico" {
  const q = new URLSearchParams(window.location.search);
  if (["gclid", "gbraid", "wbraid", "fbclid"].some((k) => q.get(k))) return "pago";
  return PAGO_MEDIUM.test(q.get("utm_medium") ?? "") ? "pago" : "organico";
}

function origemVisita(): "pago" | "organico" {
  try {
    const atual = detectar();
    const salvo = sessionStorage.getItem(KEY);
    if (atual === "pago" || !salvo) sessionStorage.setItem(KEY, atual);
    return (sessionStorage.getItem(KEY) as "pago" | "organico") ?? atual;
  } catch {
    return detectar();
  }
}

function utmsDaVisita(): Record<string, string> {
  const out: Record<string, string> = {};
  try {
    const q = new URLSearchParams(window.location.search);
    const daUrl = Object.fromEntries(UTMS.map((k) => [k, q.get(k) ?? ""]).filter(([, v]) => v));
    if (Object.keys(daUrl).length) {
      sessionStorage.setItem(UTM_KEY, JSON.stringify(daUrl));
      return daUrl as Record<string, string>;
    }
    const raw = JSON.parse(sessionStorage.getItem(UTM_KEY) || "{}") as Record<string, string | null>;
    for (const k of UTMS) if (raw[k]) out[k] = String(raw[k]);
  } catch {
    /* ignora */
  }
  return out;
}

let instalado = false;
export function instalarOrigemBlack() {
  if (instalado || typeof window === "undefined") return;
  instalado = true;
  origemVisita();
  utmsDaVisita();
  const switchLinks = () => {
    if (window.location.pathname.startsWith("/admin")) return;
    const current = window.location.pathname + window.location.search + window.location.hash;
    const destination = blackScheduledHref(current, Date.now());
    if (destination !== current) { window.location.replace(destination); return; }
    document.querySelectorAll<HTMLAnchorElement>("a[href*='/black-lista'], a[href*='/black-quizz']").forEach((a) => {
      const u = new URL(a.href, window.location.origin);
      if (![window.location.hostname, "fisioemortopedia.com.br", "www.fisioemortopedia.com.br"].includes(u.hostname)) return;
      const next = blackScheduledHref(a.href, Date.now());
      if (next !== a.href) a.href = next;
    });
  };
  switchLinks();
  window.setInterval(switchLinks, 1000);
  document.addEventListener(
    "click",
    (e) => {
      const a = (e.target as HTMLElement | null)?.closest?.("a[href*='/black-lista'], a[href*='/black-quizz'], a[href*='/black-oferta']") as HTMLAnchorElement | null;
      if (!a) return;
      try {
        const u = new URL(a.href, window.location.origin);
        if (!["/black-lista", "/black-lista-entregas", "/black-quizz", "/black-oferta", "/black-oferta-entregas"].includes(u.pathname)) return;
        if (![window.location.hostname, "fisioemortopedia.com.br", "www.fisioemortopedia.com.br"].includes(u.hostname)) return;
        u.pathname = blackScheduledHref(u.pathname, Date.now());
        const utms = utmsDaVisita();
        if (u.searchParams.has("ponto")) {
          for (const k of UTMS) u.searchParams.delete(k);
          for (const [k, v] of Object.entries(utms)) u.searchParams.set(k, v);
          if (!utms.utm_source) u.searchParams.set("utm_source", "direto");
        }
        u.searchParams.set("visita", origemVisita());
        a.href = u.toString();
        // TanStack Links otherwise navigate using their original route prop.
        if (u.pathname.startsWith("/black-oferta") && a.dataset.status !== undefined) {
          e.preventDefault();
          e.stopPropagation();
          window.location.assign(a.href);
        }
      } catch {
        /* ignora */
      }
    },
    true,
  );
}
